import http from '@/util/http';

export default {
	
	getVoiceRateplan(){
		return http.get('ChangeVoiceTariff4G/api/getVoiceRateplan');
	},
	changeVoiceRateplan(rateplanId, changeDate){
		return http.get('ChangeVoiceTariff4G/api/changeVoiceRateplan',{params:{rateplanId, changeDate}});
	},
}


// WEBPACK FOOTER //
// ./src/api/changeVoiceTariff4G/changeVoiceTariff4GApi.js